import { ReactNode } from 'react';
import { cn } from '../../lib/utils';

interface CardProps {
  children: ReactNode;
  className?: string;
  onClick?: () => void;
}

export function Card({ children, className, onClick }: CardProps) {
  return (
    <div
      className={cn(
        'bg-white dark:bg-black rounded-xl border border-gray-200 dark:border-gray-800 shadow-sm',
        onClick ? 'hover:shadow-md hover:border-gray-300 dark:hover:border-gray-700 transition-all cursor-pointer' : '',
        className
      )}
      onClick={onClick}
    >
      {children}
    </div>
  );
}

export function CardHeader({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={cn('p-4 border-b border-gray-200 dark:border-gray-800', className)}>{children}</div>;
}

export function CardContent({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={cn('p-4', className)}>{children}</div>;
}

export function CardFooter({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={cn('p-4 border-t border-gray-200 dark:border-gray-800', className)}>{children}</div>;
}